export const AVAILABLE_LOCALES = [
    'en_US',
    'es_ES',
    'es_CO',
    'fr_FR',
    'de_DE',
    'nl_NL',
    'no_NO',
    'pt_PT',
    'pt_BR',
    'id_ID',
    'da_DK',
    'pl_PL',
    'ar_SA',
    'zh_CN',
    'cs_CZ',
    'fr_CA',
    'it_IT',
    'ja_JP',
    'km_KH',
    'ko_KR',
    'ms_MY',
    'mn_MN',
    'ro_RO',
    'ru_RU',
    'si_LK',
    'sv_SE',
    'ta_IN',
    'th_TH',
    'tr_TR',
    'uk_UA',
    'vi_VN'
];
